"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDescription = exports.getTitle = exports.DESCRIPTION_LENGTH_WARNING_LIMIT = exports.TITLE_LENGTH_WARNING_LIMIT = exports.MAX_DESCRIPTION_LENGTH = exports.MAX_TITLE_LENGTH = void 0;
// (C) 2019-2022 GoodData Corporation
exports.MAX_TITLE_LENGTH = 256;
exports.MAX_DESCRIPTION_LENGTH = 1024;
exports.TITLE_LENGTH_WARNING_LIMIT = 128;
exports.DESCRIPTION_LENGTH_WARNING_LIMIT = 512;
function getTitle(title) {
    if (title && title.length > exports.MAX_TITLE_LENGTH) {
        return title.substring(0, exports.MAX_TITLE_LENGTH) + "...";
    }
    return title;
}
exports.getTitle = getTitle;
function getDescription(description) {
    if (description && description.length > exports.MAX_DESCRIPTION_LENGTH) {
        return description.substring(0, exports.MAX_DESCRIPTION_LENGTH) + "...";
    }
    return description;
}
exports.getDescription = getDescription;
//# sourceMappingURL=sectionHeaderHelper.js.map